/*global Modernizr, console */
/*jslint browser:true */

(function() {
    'use strict';

    let ticking = false;

    var auto_scales = document.querySelectorAll('.auto-scale');

    if(auto_scales.length > 0) {
      // recalculate on resize
      window.addEventListener('resize', dd_calculate_auto_scale, false);
      // recalculate on dom load
      document.addEventListener('DOMContentLoaded', dd_calculate_auto_scale, false);
      // recalculate on load (assets loaded as well)
      window.addEventListener('load', dd_calculate_auto_scale);
    }

    function dd_calculate_auto_scale() {
      auto_scales.forEach((auto_scale) => {
        var scale = Math.min(auto_scale.parentNode.clientWidth / 400, 800 / 190);

        if(scale > 1) {
          scale = 1;
        }

        auto_scale.style.transform = 'scale(' + scale + ')';
      });
    }
}());
